<template>
  <span v-if="count > 0" class="nav-badge" :class="{ 'nav-badge--dot': dot }" aria-hidden="true">
    <template v-if="!dot">{{ display }}</template>
  </span>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'NavBadge',
  props: {
    count: { type: Number, default: 0 },
    // 숫자 대신 점만 (좁은 자리용)
    dot: { type: Boolean, default: false }
  },
  setup(props) {
    const display = computed(() => (props.count > 99 ? '99+' : String(props.count)))
    return { display }
  }
}
</script>

<style scoped>
.nav-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: var(--r-full);
  background: var(--color-danger);
  color: var(--color-on-accent);
  font-family: var(--font-num);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  line-height: 1;
  /*
   * 아이콘 위에 겹칠 때 경계가 보이도록 두르는 링.
   * 색을 --color-surface 로 못 박으면 어두운 좌측 레일 위에서 흰 테가 도드라진다.
   * 부모가 --nav-badge-ring 을 주면 그 색을 쓰고, 없으면 흰 표면을 가정한다.
   */
  box-shadow: 0 0 0 2px var(--nav-badge-ring, var(--color-surface));
}

.nav-badge--dot {
  min-width: 8px;
  width: 8px;
  height: 8px;
  padding: 0;
}
</style>
